import client from './client';

export interface SupportTicket {
  id: string;
  no: string;
  userId: string | null;
  contact: string | null;
  type: string;
  priority: string;
  status: 'open' | 'processing' | 'resolved' | 'closed';
  slaDueAt: string | null;
  relatedType: string | null;
  relatedId: string | null;
  title: string;
  content: string | null;
  assigneeId: string | null;
  createdAt: string;
  closedAt: string | null;
}

export interface SupportTicketEvent {
  id: string;
  actorType: string;
  action: string;
  detail: Record<string, unknown> | null;
  createdAt: string;
}

export interface TicketDetail {
  ticket: SupportTicket;
  events: SupportTicketEvent[];
  assignee: { id: string; name: string } | null;
}

export async function listSupportTickets(params: { status?: string; page?: number; pageSize?: number }) {
  const { data } = await client.get('/support/tickets', { params });
  return data as { items: SupportTicket[]; total: number };
}

export async function createSupportTicket(payload: {
  title: string;
  content?: string;
  type?: string;
  priority?: string;
  relatedType?: string;
  relatedId?: string;
  contact?: string;
}) {
  const { data } = await client.post('/support/tickets', payload);
  return data as SupportTicket;
}

export async function getSupportTicket(id: string) {
  const { data } = await client.get(`/support/tickets/${id}`);
  return data as TicketDetail;
}

export async function replySupportTicket(id: string, content: string) {
  const { data } = await client.post(`/support/tickets/${id}/reply`, { content });
  return data as SupportTicket;
}

export async function closeSupportTicket(id: string) {
  const { data } = await client.post(`/support/tickets/${id}/close`);
  return data as SupportTicket;
}
